<template>
    <div class="platform-icon" :style="{ '--platform-width': `${size}px`, '--platform-height': `${size}px` }">
        <WhatsappSvg
            v-if="platform === 'whatsapp'"
            color="green"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Whatsapp'"
        />
        <Instagram
            v-else-if="platform === 'instagram'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Instagram'"
        />
        <MessengerIcon
            v-else-if="platform === 'messenger'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Messenger'"
        />
        <MessengerIcon
            v-else-if="platform === 'telegram'"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Telegram'"
        />
        <BrowserSvg2
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
            :content="'Web'"
            v-else
        />
    </div>
</template>

<script>
import WhatsappSvg from "../../svg/WhatsappSvg.vue";
import MessengerIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import BrowserSvg2 from "../../svg/Browser2Svg.vue";
import Instagram from "../../../../svg/stepper/Instagram.vue";

export default {
    name: "PlatformIcon",
    components: { Instagram, BrowserSvg2, MessengerIcon, WhatsappSvg },
    props: {
        platform: {
            type: String,
            default: null,
        },
        size: {
            type: Number,
            default: 18,
        },
    },
};
</script>
<style lang="scss" scoped>
.platform-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--platform-width);
    height: var(--platform-height);

    svg {
        width: var(--platform-width);
        height: var(--platform-height);
    }
}
</style>
